<app-header></app-header>
<main class="pages">
    <!--PAGE Hero Section -->
    <section class="gradient-light">
        <div class="container pt-lg-5">
            <div class="row align-items-center">
                <div class="col-md-6">
                    <h1 alt="Employee satisfaction survey" class="h1-title mt-3">Employee Experience</h1>
                    <h4 class="h2-subtitle mt-lg-4 mt-2">
                        Employees who feel their voice is heard are 4.6 times more likely to feel empowered.
                    </h4>
                    <p class="sub-text mt-3 text-justify">Measure your employees experience and engagement and take your business to a path of success with the help of CViewSurvey’s employee experience survey and feedback solutions. Capture the pulse of your employees for a happier and more
                        productive working environment.A happy and satisfied employee will always go that extra mile to contribute to the growth of your business. Therefore it is important to gauge their opinion and keep them satisfied.</p>
                    <div class="mt-lg-5">
                        <a title="" class="btn btn-lg btn-success px-4 text-uppercase  mr-lg-2" data-toggle="modal" data-target="#callBack" id="callback">Request a Demo</a>
                    </div>
                </div>
                <div class="col-md-6 ">
                    <div class="page-banner-img">
                        <img class="img-fluid" alt="Employee Satisfaction Survey" title="" src="assets/employee-experience.svg">
                    </div>
                </div>
            </div>
        </div>
    </section>


    <section class="solutions py-lg-5">
        <div class="container pb-lg-5">
            <div class="col-md-12">
                <h4 class="section-title font-weight-bold text-center mb-4">A good Employee Experience can result in:</h4>
            </div>
            <div class="solution-points">
                <ul class="nav nav-tabs tab-titles">
                    <li class="tablinks active">
                        <a class="nav-link" data-id="#Pd">
                            <span class="sol-icon">
                                <img src="assets/target-audience.svg" alt="Target Audience">
                            </span>
                        </a>
                        <h6 class="sol-title  text-center">More Productivity</h6>
                    </li>

                    <li class="tablinks">
                        <a class="nav-link" data-id="#Ta">
                            <span class="sol-icon">
                                <img src="assets/brand-awareness.svg" alt="Brand Awareness">
                            </span>
                        </a>
                        <h6 class="sol-title  text-center">Attracting New Talent</h6>
                    </li>

                    <li class="tablinks">
                        <a class="nav-link" data-id="#Ba">
                            <span class="sol-icon">
                                <img src="assets/product-feedback.svg" alt="Product Feedback">
                            </span>
                        </a>
                        <h6 class="sol-title  text-center">Reducing Employee Turnover</h6>
                    </li>

                    <li class="tablinks">
                        <a class="nav-link" data-id="#Pf">
                            <span class="sol-icon">
                                <img src="assets/customer-loyalty.svg" alt="Customer's Loyalty">
                            </span>
                        </a>
                        <h6 class="sol-title  text-center">Higher Customer Satisfaction</h6>
                    </li>

                    <li class="tablinks">
                        <a class="nav-link" data-id="#Cb">
                            <span class="sol-icon">
                                <img src="assets/customer-behaviour.svg" alt="customer behavior">
                            </span>
                        </a>
                        <h6 class="sol-title  text-center">Larger Profits</h6>
                    </li>
                </ul>
                <div class="pt-2 pb-3 pb-lg-0">
                    <div id="Pd" class="tab-content" style=display:block>
                        <div>
                            Employees who tend to be satisfied in their organisations tend to improve productivity by almost 4X. They are responsible for building happier and more successful teams.
                        </div>
                    </div>

                    <div id="Ta" class="tab-content">
                        <div>
                            Happiness attracts happiness, seeing satisfied and happy employees at your organisation will automatically pull new talent towards your business, thus saving you time and energy.
                        </div>
                    </div>

                    <div id="Ba" class="tab-content">
                        <div>
                            Capture the pulse of your employees by regularly taking feedback from them, this will lead to better communication and engagement and lesser employee turnover.
                        </div>
                    </div>

                    <div id="Pf" class="tab-content">
                        <div>
                            An employee who is satisfied will work tirelessly for achieving the company’s vision and mission, and in the process will leave all his customers highly satisfied and happy.

                        </div>
                    </div>

                    <div id="Cb" class="tab-content">
                        <div>
                            Analysing employee experience often is great as it gives you data to know problem areas, hold departments accountable and make improvements for a fulfilling profit.

                        </div>
                    </div>
                </div>

                <!-- <div class="alert alert-success blockquote mt-lg-5" role="alert">
                    The CViewSurvey provides you with the key to understand the complete life cycle of your employees from recruiting to on boarding. However, organizations that prioritize the Employee Experience grow and increase the revenue more.

                </div> -->

            </div>
        </div>
    </section>

    <section class="bg-primary py-lg-5 mt-lg-5 position-relative">
        <div class="container">
            <div class="row">
                <div class="col-lg-8 offset-lg-2">
                    <div class="solution-video">
                        <iframe width="580" height="335" [src]="safeURL" frameborder="0" allowfullscreen></iframe>
                    </div>
                </div>
            </div>
        </div>
    </section>
</main>
<app-footer></app-footer>